import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
export interface LabeledValueProps {
  label: string;
  value: string;
  className?: string;
}
function LabeledValue(t0) {
  const $ = _c(10);
  const {
    label,
    value,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-foreground/30 text-sm/5.5 font-semibold">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== value) {
    t3 = <span className="text-foreground text-sm/5.5 font-semibold">{value}</span>;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export { LabeledValue };